'use es6';

import { useState } from 'react';
import I18n from 'I18n';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UITextInput from 'UIComponents/input/UITextInput';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIFormControl from 'UIComponents/form/UIFormControl';
import H2 from 'UIComponents/elements/headings/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.createForm.withNameModal.${key}`;
const getDefaultFormName = defaultFormNamePrefix => defaultFormNamePrefix ? unescapedText(i18nKey('defaultFormName'), {
  pageTitle: defaultFormNamePrefix,
  timestamp: I18n.moment().portalTz().format('LL LTS z')
}) : '';
const Header = ({
  onCloseClick,
  headerText
}) => /*#__PURE__*/_jsxs(UIDialogHeader, {
  children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
    onClick: onCloseClick
  }), /*#__PURE__*/_jsx(H2, {
    children: headerText
  })]
});
const Body = ({
  isConflictError,
  name,
  onNameChange
}) => /*#__PURE__*/_jsx(UIDialogBody, {
  children: /*#__PURE__*/_jsx(UIFormControl, {
    error: isConflictError,
    validationMessage: isConflictError && /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('error.conflict')
    }),
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('name')
    }),
    children: /*#__PURE__*/_jsx(UITextInput, {
      value: name,
      onChange: ({
        target: {
          value
        }
      }) => onNameChange(value)
    })
  })
});
const Footer = ({
  isCreating,
  onCreateClick,
  onCancelClick,
  createText,
  isCreateDisabled
}) => /*#__PURE__*/_jsxs(UIDialogFooter, {
  children: [/*#__PURE__*/_jsx(UILoadingButton, {
    loading: isCreating,
    onClick: onCreateClick,
    disabled: isCreateDisabled,
    use: "primary",
    children: createText
  }), /*#__PURE__*/_jsx(UIButton, {
    onClick: onCancelClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('cancel')
    })
  })]
});
const CreateFormWithNameModal = ({
  defaultFormNamePrefix = '',
  isCreating = false,
  isConflictError = false,
  onCreateClick = () => {},
  onCancelClick = () => {},
  headerText = '',
  createText = ''
}) => {
  const [name, setName] = useState(getDefaultFormName(defaultFormNamePrefix));
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-selenium": "form-create-modal",
    children: [/*#__PURE__*/_jsx(Header, {
      onCloseClick: onCancelClick,
      headerText: headerText
    }), /*#__PURE__*/_jsx(Body, {
      name: name,
      isConflictError: isConflictError,
      onNameChange: setName
    }), /*#__PURE__*/_jsx(Footer, {
      isCreating: isCreating,
      onCreateClick: () => onCreateClick(name),
      onCancelClick: onCancelClick,
      createText: createText,
      isCreateDisabled: name.length === 0
    })]
  });
};
export default CreateFormWithNameModal;